import React from 'react';
import HindiCCA1to52025 from 'views/HindiCCA1to52025'


const SchoolProgrampage = () => {
  return <HindiCCA1to52025 />;
};

export default SchoolProgrampage;